/* eslint-disable */
import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./graph_overlay.css";
import HistoryList from "../includes/HistoryList";
import Engine from "../Engine";
import { Game, decode, getServerTime } from "../../../../Helper";
import Menus from "../includes/Menus";
import MarketTicker from "../../../Components/Game/Addons/MarketTicker";
import socket from "../../../../Socket";
import C from "../../../../Constant";
import storage from "../../../../Storage";


class Canvas extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.isStopGame = React.createRef();
        this.isStopGame.current = true;
        this.gameISStarted = React.createRef();
        this.gameISStarted.current = false;
        this.engine = Engine;
        this.FPS = 30;
        this.startTime = null;
        this.serverElapsed = 0;
        this.lastMult = 1.00; // Track last bust multiplier for continuation
        this.speedPxPerSecond = 60; // Kept for potential future use
        this.chartMargin = 60;
        this.maxChartY = 50;
        this.baseY = 1000; // Adjusted for height 1050 (1050 - 50 margin)
        this.points = []; // Will hold bust points {x, y, mult}
        this.history = [];
        this.expectedRoundTime = 2250; // Default, will be calculated from history
        this.startRoundX = this.chartMargin;
        this.currentRoundIndex = 0;
        this.maxPoints = 50; // Limit to last 70 points (will be adjusted by zoom)
        this.zoomLevel = 1.4; // Zoom level: 0.33 = zoomed in (23 pts), 1.0 = normal (70 pts), 2.0 = zoomed out (140 pts)
        this.minZoom = 0.33; // Min zoom (10 points)
        this.maxZoom = 2.0; // Max zoom (140 points)
        this.isAnimating = false; // Flag to control animation loop
        this.averageBust = 1.00; // Initialize to avoid NaN
        this.yScaleMax = 50; // Dynamic max for Y scaling
        this.lastCrashPoint = null; // Store last crash point for persistent display

        // Animation state for smooth line drawing
        this.animatedX = 0; // Current animated X position for progressive drawing
        this.lastLiveX = 0; // Last known live point X position
        this.animationSpeed = 0.15; // How fast the line draws (0-1, higher = faster)
        this.lastTouchDistance = null; // Store distance between fingers for pinch zoom

        this.state = {
            imagesLoaded: true,
            loadingError: null,
            engine: Engine,
            connecting: true,
            hash: null,
            status: "",
            timer: "",
            rate: "",
            timePassed: 0,
            hoveredPoint: null,
            liveTraders: 1055 + Math.floor(Math.random() * 90),
            chartType: 'candle', // 'line' or 'candle'
            selectedSymbol: storage.getKey('selected_market_ticker') || 'USD-CAD',
            loadingMarket: false,
        };


        this.popups = []; // Array to hold floating profit popups {x, y, text, alpha}

        this.animationRef = {
            gameLoop: null,
        };
        this.currentLerpMult = 1.00;
        this.isLiveAnimating = false;     // Keeps RAF running for ticker updates
        this.lastTickerTime = 0;

        this.drawChart = this.drawChart.bind(this);
        this.gameLoop = this.gameLoop.bind(this);
        this.clearAnimationData = this.clearAnimationData.bind(this);
        this.finish = this.finish.bind(this);
        this.busted = this.busted.bind(this);
        this.status = this.status.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.findNearestPoint = this.findNearestPoint.bind(this);
        this.handleWheel = this.handleWheel.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.addProfitPopup = this.addProfitPopup.bind(this);
        this.startLiveTradersSimulation = this.startLiveTradersSimulation.bind(this);
        this.simulateNextActivity = this.simulateNextActivity.bind(this);
        this.toggleChartType = this.toggleChartType.bind(this);
        this.handleMarketSymbolChange = this.handleMarketSymbolChange.bind(this);
        this.fetchTickerHistory = this.fetchTickerHistory.bind(this);


        // Easing functions for smooth progress
        this.easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        this.easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    toggleChartType(type) {
        if (this.state.chartType !== type) {
            this.setState({ chartType: type }, () => {
                const ctx = this.canvasRef.current?.getContext('2d');
                if (ctx) this.drawChart(ctx);
            });
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ imagesLoaded: true });

        // Helper: subscribe + request history for a symbol
        this.subscribeToSymbol = (symbol) => {
            // console.log(`[TICKER] Subscribing to ${symbol}`);
            socket.emit(C.TICKER_SUBSCRIBE, { ticker: symbol });
            this.fetchTickerHistory(symbol);
        };

        // Register TICKER_UPDATE listener first so we never miss an event
        this.handleTickerUpdate = (data) => {
            const decoded = decode(data);
            if (decoded && (decoded.ticker === this.state.selectedSymbol || decoded.symbol === this.state.selectedSymbol)) {
                if (decoded.data) {
                    const item = decoded.data;
                    Game['current_amount'] = item.close;

                    // Capture offset to synchronize ManualBet entry/expiry with the chart's timeline
                    const measuredOffset = Date.now() - item.timestamp;
                    if (typeof Game['server_time_offset'] === 'undefined') {
                        Game['server_time_offset'] = measuredOffset;
                    } else {
                        Game['server_time_offset'] = (Game['server_time_offset'] * 0.8) + (measuredOffset * 0.2);
                    }

                    if (this.points.length > 0) {
                        const lastPoint = this.points[this.points.length - 1];
                        if (lastPoint.timestamp === item.timestamp) {
                            lastPoint.open = item.open;
                            lastPoint.high = Math.max(lastPoint.high, item.high);
                            lastPoint.low = Math.min(lastPoint.low, item.low);
                            lastPoint.close = item.close;
                            lastPoint.mult = item.close;
                        } else {
                            this.points.push({
                                timestamp: item.timestamp,
                                mult: item.close,
                                open: item.open,
                                high: item.high,
                                low: item.low,
                                close: item.close,
                                volume: item.volume
                            });
                            if (this.points.length > 300) this.points.shift();
                        }
                    } else {
                        this.points.push({ ...item, mult: item.close });
                    }

                    // Store the latest ticker timestamp on the engine so ManualBet can
                    // snap the trade entryTime to the last real data point (prevents future drift).
                    this.engine._lastTickerTimestamp = item.timestamp;

                    // Force animation loop — restart if killed by waiting()/busted()
                    this.isLiveAnimating = true;
                    if (!this.isAnimating) {
                        this.isAnimating = true;
                        this.gameLoop();
                    }
                }
            }
        };
        socket.on(C.TICKER_UPDATE, this.handleTickerUpdate);

        // Subscribe on connect AND reconnect so the emit is never lost
        this.handleSocketConnect = () => {
            setTimeout(() => {
                if (this._isMounted) {
                    // console.log(`[TICKER] Socket connected — subscribing to ${this.state.selectedSymbol}`);
                    this.subscribeToSymbol(this.state.selectedSymbol);
                }
            }, 1500);
        };
        socket.on('connect', this.handleSocketConnect);

        // Also subscribe immediately if socket is already connected (with delay for backend readiness)
        if (socket.connected) {
            setTimeout(() => {
                if (this._isMounted) {
                    // console.log(`[TICKER] Socket already connected — subscribing to ${this.state.selectedSymbol}`);
                    this.subscribeToSymbol(this.state.selectedSymbol);
                }
            }, 1500);
        }

        // Listen for market history
        socket.on(C.TICKER_HISTORY, (data) => {
            const decoded = decode(data);

            if (decoded && (decoded.symbol === this.state.selectedSymbol || decoded.ticker === this.state.selectedSymbol)) {
                // console.log(`[TICKER HISTORY MATCHED] for ${this.state.selectedSymbol}`);
                if (decoded.history && Array.isArray(decoded.history)) {
                    this.points = decoded.history.map(item => ({
                        timestamp: item.timestamp,
                        mult: item.close,
                        open: item.open,
                        high: item.high,
                        low: item.low,
                        close: item.close,
                        volume: item.volume
                    }));

                    // Snap lerp to actual price so candles don't animate from 1.00 on first draw
                    if (this.points.length > 0) {
                        this.currentLerpMult = this.points[this.points.length - 1].close;
                    }

                    this.setState({ connecting: false });
                    if (this.canvasRef.current) {
                        const ctx = this.canvasRef.current.getContext('2d');
                        if (ctx) this.drawChart(ctx);
                    }
                }
            }
        });

        // Important: Subscribe to Engine events immediately, even if canvas is not yet rendered (connecting state)
        this.engine.trigger.on("finish_crash", (data) => this.finish(data));
        this.engine.trigger.on("busted_crash", (data) => this.busted(data));
        this.engine.trigger.on("game_status", (data) => this.status(data));
        this.engine.trigger.on("visual_profit", (data) => this.addProfitPopup(data));

        if (!this.state.connecting) {
            this.initCanvas();
        }

        this.startLiveTradersSimulation();
        this.simulateNextActivity();
    }

    fetchTickerHistory(symbol) {
        // console.log("FETCHING TICKER HISTORY FOR:", symbol);
        socket.emit(C.TICKER_HISTORY, { ticker: symbol });
    }


    handleMarketSymbolChange(newSymbol) {
        // console.log("MARKET SYMBOL CHANGED IN PARENT (MOBILE):", newSymbol);
        if (this.state.selectedSymbol && this.state.selectedSymbol !== newSymbol) {
            // console.log(`[TICKER] Emitting UNSUBSCRIBE for ${this.state.selectedSymbol}`);

            socket.emit(C.TICKER_UNSUBSCRIBE, {
                ticker: this.state.selectedSymbol
            });
        }
        this.points = []; // Clear old points before loading new symbol
        this.setState({ selectedSymbol: newSymbol, loadingMarket: true, connecting: true });
        storage.setKey('selected_market_ticker', newSymbol);
        this.subscribeToSymbol(newSymbol);

        setTimeout(() => {
            if (this._isMounted) {
                this.setState({ loadingMarket: false });
            }
        }, 1000);
    }


    componentDidUpdate(prevProps, prevState) {
        // When connecting state changes to false, the canvas is rendered, so we initialize it
        if (prevState.connecting && !this.state.connecting) {
            this.initCanvas();
        }
    }

    initCanvas() {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        canvas.width = 1080;
        canvas.height = 1050;

        // Mouse event listeners for hover tooltip
        canvas.addEventListener('mousemove', this.handleMouseMove);
        canvas.addEventListener('mouseleave', this.handleMouseLeave);
        canvas.addEventListener('wheel', this.handleWheel, { passive: false });

        // Touch event listeners for pinch to zoom
        canvas.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        canvas.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        canvas.addEventListener('touchend', this.handleTouchEnd);

        // Only draw if we have data; otherwise first draw will happen when status() arrives
        if (this.points.length > 0) {
            this.drawChart(ctx);
        }
    }

    startLiveTradersSimulation() {
        this.tradersInterval = setInterval(() => {
            if (!this._isMounted) return;
            this.setState(prevState => {
                const drift = (1000 - prevState.liveTraders) * 0.05; // Drift towards 1000
                const randomChange = (Math.random() * 6) - 3; // Believable fluctuation -3 to +3
                const newCount = Math.round(prevState.liveTraders + drift + randomChange);
                return { liveTraders: newCount };
            });
        }, 3000);
    }

    simulateNextActivity() {
        if (!this._isMounted) return;

        // Calculate a random delay for the next activity (between 80ms and 600ms for higher frequency)
        const nextDelay = Math.floor(Math.random() * 520) + 80;

        this.activityTimeout = setTimeout(() => {
            if (!this._isMounted) return;

            // Allow up to 3 active simulated popups at a time for a busier feed
            // Allow up to 3 active simulated popups at a time for a busier feed
            // Don't spawn simulated popups when player has an active trade
            const hasActiveTrades = this.engine && this.engine.activeTrades && this.engine.activeTrades.length > 0;
            if (!hasActiveTrades && this.popups.filter(p => p.isSimulated).length < 3) {
                const currentMult = parseFloat(Game['current_amount']) || 1.00;

                if (this.gameISStarted.current) {
                    // Higher base chance so popups fire very frequently
                    const chance = 0.85 / (currentMult * 0.3 + 0.3);

                    if (Math.random() < chance) {
                        const randomAmount = Math.floor(Math.random() * 280190) + 400;
                        const randomUser = `...${Math.floor(1000 + Math.random() * 9000)}`;
                        const randomType = Math.random() > 0.5 ? "buy" : "sell";

                        this.addProfitPopup({
                            mult: currentMult,
                            amount: randomAmount,
                            username: randomUser,
                            type: randomType,
                            isSimulated: true,
                            // Random ratio along the visible line (0=oldest, 1=live head)
                            spawnRatio: 0.3 + Math.random() * 0.65
                        });
                    }
                }
            }

            // Recursively call for the next activity
            this.simulateNextActivity();
        }, nextDelay);
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.isAnimating = false;
        cancelAnimationFrame(this.animationRef.gameLoop);
        this.clearAnimationData();

        if (this.handleTickerUpdate) {
            if (this.state.selectedSymbol) {
                socket.emit(C.TICKER_UNSUBSCRIBE, {
                    ticker: this.state.selectedSymbol
                });
            }
            socket.off(C.TICKER_UPDATE, this.handleTickerUpdate);
        }

        if (this.handleSocketConnect) {
            socket.off('connect', this.handleSocketConnect);
        }

        // Remove mouse event listeners
        const canvas = this.canvasRef.current;
        if (canvas) {
            canvas.removeEventListener('mousemove', this.handleMouseMove);
            canvas.removeEventListener('mouseleave', this.handleMouseLeave);
            canvas.removeEventListener('wheel', this.handleWheel);
            canvas.removeEventListener('touchstart', this.handleTouchStart);
            canvas.removeEventListener('touchmove', this.handleTouchMove);
            canvas.removeEventListener('touchend', this.handleTouchEnd);
        }

        if (this.tradersInterval) {
            clearInterval(this.tradersInterval);
        }
        if (this.activityTimeout) {
            clearTimeout(this.activityTimeout);
        }
    }

    // Add a new floating profit popup
    addProfitPopup(data) {
        if (!this._isMounted) return;

        const { mult, amount, username, isSimulated, type, spawnRatio } = data;
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        // Calculate position based on current scale
        const pointsToUse = this.points.slice(-Math.round(60 * this.zoomLevel));
        const { scaleFactor } = this.computeYScale(pointsToUse, mult);
        const y = this.getYForMult(mult, scaleFactor);

        // X position is always the current "head" of the line (75% of width)
        const x = canvas.width * 0.75;

        // Calculate vertical offset for simulated traders (above or below line)
        let offset = 0;
        if (isSimulated) {
            offset = (Math.random() * 80) - 40; // +/- 40px offset to spread popups vertically
        }

        this.popups.push({
            x: x,
            y: y, // Initial y, but will be recalculated in drawChart
            mult: mult, // Store mult to find position on graph
            offset: offset, // Store vertical offset relative to line
            type: type || "buy", // Default to buy (green)
            username: username || "WON",
            text: `x${mult.toFixed(2)}`,
            subtext: `+KES ${parseFloat(amount).toFixed(0)}`,
            alpha: 1.0,
            isSimulated: isSimulated || false,
            spawnRatio: spawnRatio !== undefined ? spawnRatio : null
        });
    }
    // Helper to compute dynamic Y scale and labels (trading-style with small margins)
    computeYScale(visiblePoints, currentMult = null) {
        const allMults = visiblePoints.map(p => p.mult).concat(currentMult ? [currentMult] : []);

        // No data at all — return safe defaults without labels that would show 1.00
        if (allMults.length === 0) {
            this.yScaleMin = 1.00;
            this.yScaleMax = 1.80;
            this.yLabelPrecision = 2;
            const scaleFactor = (this.baseY - this.maxChartY) / (1.80 - 1.00);
            const labels = [];
            const labelCount = 11;
            const labelStep = (1.80 - 1.00) / (labelCount - 1);
            for (let i = 0; i < labelCount; i++) {
                labels.push(parseFloat((1.00 + i * labelStep).toFixed(2)));
            }
            return { scaleFactor, labels, minY: 1.00, maxY: 1.80 };
        }

        // Calculate dynamic range based on actual data
        let dataMin = Math.min(...allMults);
        let dataMax = Math.max(...allMults);

        // Ensure we have at least some data, fallback to a reasonable range if empty or too small
        if (!isFinite(dataMin) || !isFinite(dataMax) || dataMax <= 1.00) {
            dataMin = 1.00;
            dataMax = 1.80; // Healthier range for initial empty state
        }

        // Add small padding (0.5% on each side) for better visualization
        const range = dataMax - dataMin;
        const padding = Math.max(range * 0.005, 0.001); // At least 0.001 padding

        // Enforce minimum range to ensure small differences are visible
        const minRange = 0.01; // Minimum 0.01 range for visibility
        let minY = dataMin - padding;
        let maxY = dataMax + padding;

        // If the range is too small, expand it symmetrically
        const currentRange = maxY - minY;
        if (currentRange < minRange) {
            const expansion = (minRange - currentRange) / 2;
            minY -= expansion;
            maxY += expansion;
        }

        // Store for use in rendering
        this.yScaleMin = minY;
        this.yScaleMax = maxY;

        // Prevent Y labels from starting at exactly 1.00 unless necessary for very low crashes
        // If the lowest point is above 1.10, push the bottom label to 1.10 or higher for better floor clearance
        if (this.yScaleMin <= 1.05 && dataMin > 1.10) {
            this.yScaleMin = 1.10;
        } else if (this.yScaleMin < 1.00) {
            this.yScaleMin = 1.00; // Cap at 1.00 as absolute bottom if padding pushed it below
        }

        // Refresh local variables after refinement logic to ensure labels and scale factor are correct
        minY = this.yScaleMin;
        maxY = this.yScaleMax;

        // Calculate scale factor
        const scaleFactor = (this.baseY - this.maxChartY) / (maxY - minY);

        // Generate dynamic labels with appropriate precision
        const labels = [];
        const labelCount = 11; // Number of labels to display
        const labelStep = (maxY - minY) / (labelCount - 1);

        // Determine precision based on step size (for trading-like display)
        let precision = 4; // Default to 4 decimal places for 0.0001 precision
        if (labelStep >= 0.01) precision = 2;
        else if (labelStep >= 0.001) precision = 3;
        else if (labelStep >= 0.0001) precision = 4;
        else precision = 5;

        // Store precision for use in rendering labels
        this.yLabelPrecision = precision;

        for (let i = 0; i < labelCount; i++) {
            const value = minY + i * labelStep;
            labels.push(parseFloat(value.toFixed(precision)));
        }

        return { scaleFactor, labels, minY, maxY };
    }

    // Helper to get Y position for a multiplier
    getYForMult(mult, scaleFactor) {
        const minY = (this.yScaleMin !== undefined && this.yScaleMin !== null) ? this.yScaleMin : 1.00;
        const y = this.baseY - (mult - minY) * scaleFactor;
        return Math.max(this.maxChartY, Math.min(y, this.baseY));
    }

    // Handle mouse move for hover tooltip
    handleMouseMove(event) {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const mouseX = (event.clientX - rect.left) * scaleX;
        const mouseY = (event.clientY - rect.top) * scaleY;

        const nearestPoint = this.findNearestPoint(mouseX, mouseY);
        if (nearestPoint !== this.state.hoveredPoint) {
            this.setState({ mousePos: { x: mouseX, y: mouseY }, hoveredPoint: nearestPoint }, () => {
                const ctx = canvas.getContext('2d');
                if (ctx) this.drawChart(ctx);
            });
        }
    }

    // Handle mouse leave to clear tooltip
    handleMouseLeave() {
        if (this.state.hoveredPoint || this.state.mousePos) {
            this.setState({ mousePos: null, hoveredPoint: null }, () => {
                const canvas = this.canvasRef.current;
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    if (ctx) this.drawChart(ctx);
                }
            });
        }
    }

    // Handle mouse wheel for zoom
    handleWheel(event) {
        event.preventDefault();

        const zoomDelta = event.deltaY > 0 ? 0.1 : -0.1;
        const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel + zoomDelta));

        if (newZoom !== this.zoomLevel) {
            this.zoomLevel = newZoom;

            // Force redraw
            const canvas = this.canvasRef.current;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                if (ctx) this.drawChart(ctx);
            }
        }
    }

    // Handle touch start for pinch zoom
    handleTouchStart(event) {
        if (event.touches.length === 2) {
            event.preventDefault(); // Prevent page scroll
            const distance = Math.hypot(
                event.touches[0].clientX - event.touches[1].clientX,
                event.touches[0].clientY - event.touches[1].clientY
            );
            this.lastTouchDistance = distance;
        }
    }

    // Handle touch move for pinch zoom
    handleTouchMove(event) {
        if (event.touches.length === 2 && this.lastTouchDistance !== null) {
            event.preventDefault(); // Prevent page scroll

            const newDistance = Math.hypot(
                event.touches[0].clientX - event.touches[1].clientX,
                event.touches[0].clientY - event.touches[1].clientY
            );

            if (newDistance > 0) {
                // Calculate zoom ratio
                const delta = newDistance - this.lastTouchDistance;
                // Sensitivity factor
                const zoomDelta = delta * 0.005;

                // Pinch OUT (spreading fingers) -> Zooms IN (shows fewer points)
                const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel - zoomDelta));

                if (newZoom !== this.zoomLevel) {
                    this.zoomLevel = newZoom;
                    this.lastTouchDistance = newDistance; // Update for continuous zoom

                    // Force redraw
                    const canvas = this.canvasRef.current;
                    if (canvas) {
                        const ctx = canvas.getContext('2d');
                        if (ctx) this.drawChart(ctx);
                    }
                }
            }
        }
    }

    // Handle touch end
    handleTouchEnd(event) {
        if (event.touches.length < 2) {
            this.lastTouchDistance = null;
        }
    }

    // Find nearest point to mouse cursor
    findNearestPoint(mouseX, mouseY) {
        const threshold = 50; // pixels (increased for finger touch)
        const basePoints = 60;
        const visiblePointCount = Math.round(basePoints * this.zoomLevel);
        const visiblePoints = this.points.slice(-visiblePointCount);
        const canvas = this.canvasRef.current;
        if (!canvas || visiblePoints.length === 0) return null;

        const { width: w } = canvas;
        const numVisible = visiblePoints.length;
        const step = numVisible > 0 ? (w - 2 * this.chartMargin) / numVisible : 50;

        // Rescale points to current positions
        const drawPointsBase = visiblePoints.map((p, i) => ({
            ...p,
            x: this.chartMargin + i * step
        }));

        // Compute Y positions
        const { scaleFactor: yScaleFactor } = this.computeYScale(drawPointsBase, null);
        const drawPoints = drawPointsBase.map(p => ({
            ...p,
            y: this.getYForMult(p.mult, yScaleFactor)
        }));

        let nearestPoint = null;
        let minDistance = threshold;

        drawPoints.forEach(point => {
            const distance = Math.sqrt(
                Math.pow(point.x - mouseX, 2) + Math.pow(point.y - mouseY, 2)
            );
            if (distance < minDistance) {
                minDistance = distance;
                nearestPoint = point;
            }
        });

        return nearestPoint;
    }

    // Group visible points into OHLC candles based on time intervals
    groupPointsIntoCandles(points, timeWindowMs = 5000) {
        if (!points || points.length === 0) return { historicalCandles: [], liveCandle: null };

        const historicalCandles = [];
        let currentCandle = null;
        let currentBin = null;

        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            const pointTime = point.timestamp || (Date.now() - (points.length - i) * 1000);
            const bin = Math.floor(pointTime / timeWindowMs);

            if (currentBin !== bin || currentCandle === null) {
                // Close previous candle (it becomes historical)
                if (currentCandle) {
                    historicalCandles.push(currentCandle);
                }

                // Start new candle
                currentCandle = {
                    open: point.open !== undefined ? point.open : point.mult,
                    high: point.high !== undefined ? point.high : point.mult,
                    low: point.low !== undefined ? point.low : point.mult,
                    close: point.close !== undefined ? point.close : point.mult,
                    binStartTime: pointTime,
                    isLive: false
                };
                currentBin = bin;
            } else {
                // Update current candle
                const pHigh = point.high !== undefined ? point.high : point.mult;
                const pLow = point.low !== undefined ? point.low : point.mult;
                const pClose = point.close !== undefined ? point.close : point.mult;

                currentCandle.high = Math.max(currentCandle.high, pHigh);
                currentCandle.low = Math.min(currentCandle.low, pLow);
                currentCandle.close = pClose;
            }
        }

        // The very last candle is always the live one (to show current ticker price)
        let liveCandle = null;
        if (currentCandle) {
            liveCandle = { ...currentCandle, isLive: true };
        }

        return { historicalCandles, liveCandle };
    }

    drawCandlesticks(ctx, allPoints, yScaleFactor, liveMult, timeWindowMs = 3000) {
        if (!allPoints || allPoints.length === 0) return null;

        const { historicalCandles, liveCandle } = this.groupPointsIntoCandles(allPoints, timeWindowMs);

        // Filter to last N candles based on zoom/visible points
        const basePoints = 60;
        const visiblePointCount = Math.round(basePoints * this.zoomLevel);
        const pointsPerCandle = timeWindowMs / 1000;
        const maxVisibleCandles = Math.ceil(visiblePointCount / pointsPerCandle);
        const visibleHistorical = historicalCandles.slice(-maxVisibleCandles);

        // Calculate even candle spacing (real trading chart style)
        const totalCandles = visibleHistorical.length + (liveCandle ? 1 : 0);
        if (totalCandles === 0) return null;

        const canvas = this.canvasRef.current;
        const w = canvas.width;
        const candleStep = totalCandles > 1
            ? (w * 0.75) / (totalCandles - 1)
            : 60;

        const candleWidth = Math.max(4, Math.floor(candleStep * 0.55));
        const wickWidth = Math.max(1, Math.floor(candleWidth * 0.12));

        ctx.save();
        let liveInfo = null;

        // Build candle layout map for entry-point snapping
        const candleLayout = [];

        // === 1. Draw all closed (historical) candles ===
        // NOTE: Candles start at x=0 (no chartMargin offset) to stay aligned with
        // the line chart's drawPointsBase coordinate system (also starts at x=0).
        // Adding chartMargin here would shift all candle positions by 60px relative
        // to the line chart, causing entry markers and the stableMsPerPixel safety
        // clamp to reference mismatched coordinate spaces.
        visibleHistorical.forEach((candle, idx) => {
            const x = idx * candleStep;
            this.drawSingleCandle(ctx, candle, x, candleWidth, wickWidth, yScaleFactor, false);
            candleLayout.push({ binStartTime: candle.binStartTime, x, timeWindowMs });
        });

        // === 2. Draw the LIVE candle (always at rightmost position) ===
        if (liveCandle && liveMult != null) {
            // Update live candle with real-time multiplier
            liveCandle.close = liveMult;
            if (liveMult > liveCandle.high) liveCandle.high = liveMult;
            if (liveMult < liveCandle.low) liveCandle.low = liveMult;

            const liveIndex = visibleHistorical.length;
            const liveX = liveIndex * candleStep;   // ← FIXED position, no chartMargin offset

            this.drawSingleCandle(ctx, liveCandle, liveX, candleWidth, wickWidth, yScaleFactor, true);
            candleLayout.push({ binStartTime: liveCandle.binStartTime, x: liveX, timeWindowMs });

            // Return live info so the glowing blue dot stays exactly in the middle
            const liveY = this.getYForMult(liveMult, yScaleFactor);
            liveInfo = { liveX, liveY, liveMult };
        }

        // Expose candle layout so trade annotations can snap entry indicators to candle centres
        this._candleLayout = candleLayout;
        this._candleTimeWindowMs = timeWindowMs;

        ctx.restore();
        return liveInfo;
    }


    // Helper: draw one candle (kept clean)
    drawSingleCandle(ctx, candle, x, candleWidth, wickWidth, yScaleFactor, isLive) {
        const { open, high, low, close, isBullish = close >= open } = candle;

        const yOpen = this.getYForMult(open, yScaleFactor);
        const yClose = this.getYForMult(close, yScaleFactor);
        const yHigh = this.getYForMult(high, yScaleFactor);
        const yLow = this.getYForMult(low, yScaleFactor);

        const color = isLive
            ? (isBullish ? '#16ff9a' : '#ff5b5b')
            : (isBullish ? '#10d392ff' : '#f72c2cff');

        // Wick
        // Disabled shadow for mobile performance
        ctx.strokeStyle = color;
        ctx.lineWidth = wickWidth;
        ctx.beginPath();
        ctx.moveTo(x, yHigh);
        ctx.lineTo(x, yLow);
        ctx.stroke();

        // Body
        const bodyTop = Math.min(yOpen, yClose);
        const bodyBottom = Math.max(yOpen, yClose);
        let bodyHeight = bodyBottom - bodyTop;
        if (bodyHeight < 2) bodyHeight = 2;

        // Disabled shadow for mobile performance
        ctx.fillStyle = color;
        ctx.fillRect(x - candleWidth / 2, bodyTop, candleWidth, bodyHeight);
    }

    drawChart(ctx) {
        const { width: w, height: h } = ctx.canvas;
        ctx.clearRect(0, 0, w, h);

        // Transparent background - no fill needed

        // Calculate visible points based on zoom level
        const basePoints = 60; // Show more history for trades
        const visiblePointCount = Math.round(basePoints * this.zoomLevel);
        const visiblePoints = this.points.slice(-visiblePointCount);
        const numVisible = visiblePoints.length;
        // Graph spans 75% of width: step = (w * 0.75) / (numVisible - 1)
        const step = numVisible > 1 ? (w * 0.75) / (numVisible - 1) : 0;
        const drawPointsBase = visiblePoints.map((p, i) => ({
            ...p,
            x: i * step  // Rescale x to fit within 75% of width
        }));

        let displayRate = Game['current_amount'] || "1.00";
        let livePoint = null;
        let currentMult = this.currentLerpMult;

        // Live rising line during started (continuation from last point, no reset)
        if (this.state.status === "started" && this.startTime) {
            const lastPoint = drawPointsBase.length > 0 ? drawPointsBase[drawPointsBase.length - 1] : { x: 0, y: this.baseY, mult: 1.50 };
            const lastBustX = lastPoint.x;
            const lastMult = lastPoint.mult;
            const elapsed = Date.now() - this.startTime;
            const linearProgress = Math.min(elapsed / this.expectedRoundTime, 1);
            const easedProgress = this.easeInOutCubic(linearProgress); // Apply easing for smoothness
            const currentX = lastBustX + easedProgress * step;

            // Calculate growth from server-synced startTime
            const growth = Math.exp(0.0007 * elapsed);
            const live_mult = lastMult * growth;

            if (this.state.chartType === 'line') {
                // Original line smoothing/lerping logic
                displayRate = live_mult.toFixed(2);

                const { scaleFactor: liveScaleFactor } = this.computeYScale(drawPointsBase, currentMult);
                const live_y = this.getYForMult(currentMult, liveScaleFactor);
                livePoint = { x: currentX, y: live_y, mult: currentMult, timestamp: Date.now(), isLive: true };
                drawPointsBase.push(livePoint);
            } else {
                // Specifically for candles, use the refined property-based lerping
                const visual_mult = currentMult;
                displayRate = visual_mult.toFixed(2);
                const { scaleFactor: liveScaleFactor } = this.computeYScale(drawPointsBase, visual_mult);
                const live_y = this.getYForMult(visual_mult, liveScaleFactor);
                livePoint = { x: currentX, y: live_y, mult: visual_mult, timestamp: Date.now(), isLive: true };
            }
        }

        // Fallback: If not started, use the latest point from history for Y-scaling and current value tracking
        if (!currentMult && drawPointsBase.length > 0) {
            currentMult = drawPointsBase[drawPointsBase.length - 1].mult;
        }


        // Compute dynamic Y scale based on points and live
        const { scaleFactor: yScaleFactor, labels: yLabels } = this.computeYScale(drawPointsBase, currentMult);
        this.yScaleFactor = yScaleFactor; // Store for use in busted()

        // Adjust draw points Y to new scale
        const drawPoints = drawPointsBase.map(p => ({
            ...p,
            y: this.getYForMult(p.mult, yScaleFactor)
        }));

        // Y-axis labels (dynamic) - on right side
        ctx.fillStyle = "#8a9ba8";
        ctx.font = "bold 24px Arial"; // Increased font size
        ctx.textAlign = "right";
        yLabels.forEach((val) => {
            let ly = this.getYForMult(val, yScaleFactor);

            // Draw horizontal grid line across full width
            ctx.strokeStyle = "rgba(68, 75, 89, 0.3)"; // Reduced opacity for subtle grid
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(0, ly);
            ctx.lineTo(w, ly);
            ctx.stroke();

            // Draw text for all labels with dynamic precision
            ctx.fillStyle = "#8a9ba8";
            const text = val.toFixed(this.yLabelPrecision || 5);
            ctx.fillText(text, w - this.chartMargin - 10, ly + 8);
        });
        // Draw the chart based on current mode
        if (this.state.chartType === 'candle') {
            // Pass ONLY historical points (no livePoint)
            const candleLive = this.drawCandlesticks(
                ctx,
                this.points,
                yScaleFactor,
                currentMult
            );
            if (candleLive) {
                livePoint = { x: candleLive.liveX, y: candleLive.liveY, mult: candleLive.liveMult };
            }
        } else if (drawPoints.length > 0) {
            if (!livePoint) {
                livePoint = drawPoints[drawPoints.length - 1];
            }
            // Permanent history + live: smooth connected line (trading chart style)
            // Save canvas state for clipping
            ctx.save();

            // If game is running and we have a live point, animate the line progressively
            if (this.state.status === "started" && drawPoints.length > 0) {
                const lastPoint = drawPoints[drawPoints.length - 1];

                // Update target X position when new data arrives
                if (lastPoint.x !== this.lastLiveX) {
                    this.lastLiveX = lastPoint.x;
                }

                // Smoothly animate toward target X
                if (this.animatedX < this.lastLiveX) {
                    this.animatedX += (this.lastLiveX - this.animatedX) * this.animationSpeed;
                }

                // Clip drawing to only show up to animated X position
                ctx.beginPath();
                ctx.rect(0, 0, this.animatedX, h);
                ctx.clip();
            }

            // Build the curve path once for both stroke and fill
            const curvePath = new Path2D();
            curvePath.moveTo(drawPoints[0].x, drawPoints[0].y);

            if (drawPoints.length > 1) {
                for (let i = 0; i < drawPoints.length - 1; i++) {
                    const p0 = i > 0 ? drawPoints[i - 1] : drawPoints[i];
                    const p1 = drawPoints[i];
                    const p2 = drawPoints[i + 1];
                    const p3 = i < drawPoints.length - 2 ? drawPoints[i + 2] : p2;

                    const cp1x = p1.x + (p2.x - p0.x) / 6;
                    const cp1y = p1.y + (p2.y - p0.y) / 6;
                    const cp2x = p2.x - (p3.x - p1.x) / 6;
                    const cp2y = p2.y - (p3.y - p1.y) / 6;

                    curvePath.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
                }
            }

            // Pass 1: Core line
            ctx.strokeStyle = "rgba(74, 159, 245, 0.85)";
            ctx.lineWidth = 4;
            ctx.stroke(curvePath);

            // Restore clipping if it was active
            ctx.restore();

            // Pass 2: Fill area below the curve
            const fillPath = new Path2D(curvePath);
            fillPath.lineTo(drawPoints[drawPoints.length - 1].x, this.baseY);
            fillPath.lineTo(drawPoints[0].x, this.baseY);
            fillPath.closePath();

            const gradient = ctx.createLinearGradient(0, this.maxChartY, 0, this.baseY);
            gradient.addColorStop(0, "rgba(74, 159, 245, 0.4)");
            gradient.addColorStop(1, "rgba(74, 159, 245, 0.05)");
            ctx.fillStyle = gradient;
            ctx.fill(fillPath);
        } // End of line chart branch

        // Horizontal line at current trading point
        if (livePoint) {
            const liveY = Math.max(this.maxChartY, Math.min(livePoint.y, h - this.chartMargin));
            // In candle mode, use the exact candle cx; in line mode use chartMargin clamp
            const liveX = this.state.chartType === 'candle'
                ? Math.max(0, Math.min(livePoint.x, w - 1))
                : Math.max(this.chartMargin, Math.min(livePoint.x, w - this.chartMargin));

            // Solid horizontal line from dot to right edge
            ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
            ctx.lineWidth = 4; // Increased width
            ctx.setLineDash([]);
            ctx.beginPath();
            ctx.moveTo(Math.min(liveX + 10, w), liveY); // Full width
            ctx.lineTo(w, liveY); // Full width
            ctx.stroke();

            // Current point indicator (glowing dot)
            ctx.save();
            // Disabled shadow for mobile performance
            ctx.fillStyle = "#4a9ff5";
            ctx.beginPath();
            ctx.arc(liveX, liveY, 10, 0, 2 * Math.PI); // Scaled radius
            ctx.fill();
            ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
            ctx.lineWidth = 2; // Scaled stroke
            ctx.stroke();
            ctx.restore();

            // Rate label at the far right end
            const rateText = `${livePoint.mult.toPrecision(7)}`;
            ctx.font = "bold 24px Arial"; // Scaled font
            ctx.fillStyle = "#fff";
            ctx.textAlign = "right";
            const labelBgWidth = ctx.measureText(rateText).width + 36; // Add generous padding
            const labelX = w; // Right aligned
            const labelY = liveY - 18;

            // Label background attached to right edge
            ctx.fillStyle = "#4a9ff5";
            ctx.fillRect(labelX - labelBgWidth + 10, labelY, labelBgWidth, 36);

            // Label text
            ctx.fillStyle = "#fff";
            ctx.fillText(rateText, labelX - 6, liveY + 8); // Scaled offset
        }

        // Bust marker (red dot + dashed vertical on last point if busted)
        if (this.state.status === "busted" && this.points.length > 0) {
            const lastP = drawPoints[drawPoints.length - 1]; // Use scaled point
            const bx = Math.max(this.chartMargin, Math.min(lastP.x, w - this.chartMargin));
            const by = Math.max(this.maxChartY, Math.min(lastP.y, h - this.chartMargin));

            // Store crash point for persistent display
            this.lastCrashPoint = { x: bx, y: by, mult: lastP.mult };

            // Vertical dashed line down from crash point
            ctx.strokeStyle = "rgba(74, 159, 245, 0.9)";
            ctx.lineWidth = 4; // Scaled width
            ctx.setLineDash([10, 10]); // Scaled dash
            ctx.beginPath();
            ctx.moveTo(bx, by);
            ctx.lineTo(bx, h - this.chartMargin);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
            ctx.beginPath();
            ctx.arc(bx, by, 12, 0, 2 * Math.PI); // Scaled radius
            ctx.fill();
        }

        // Persistent crash indicator (shows during busted and idle, until new round starts)
        if (this.lastCrashPoint && (this.state.status === "busted" || this.state.status === "idle")) {
            const { x: crashX, y: crashY, mult: crashMult } = this.lastCrashPoint;

            // Crash point marker (dot at the crash position)
            ctx.save();

            // Add pulse and glow effect ONLY when game just crashed (busted status)
            if (this.state.status === "busted") {
                // Disabled shadow for mobile performance

                // Draw pulsing outer ring (scaled for mobile)
                const pulse = (Math.sin(Date.now() / 150) + 1) / 2; // Oscillate 0 to 1
                const pulseRadius = 10 + pulse * 25;
                ctx.strokeStyle = `rgba(74, 159, 245, ${0.4 * (1 - pulse)})`;
                ctx.lineWidth = 5;
                ctx.beginPath();
                ctx.arc(crashX, crashY, pulseRadius, 0, 2 * Math.PI);
                ctx.stroke();
            }

            ctx.fillStyle = "#4a9ff5";
            ctx.beginPath();
            ctx.arc(crashX, crashY, 10, 0, 2 * Math.PI); // Scaled radius for mobile
            ctx.fill();
            ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
            ctx.lineWidth = 4; // Scaled stroke for mobile
            ctx.stroke();

            ctx.restore();

            // Horizontal line starting from crash dot (solid, not dashed)
            ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
            ctx.lineWidth = 4; // Increased width
            ctx.setLineDash([]); // Solid line
            ctx.beginPath();
            ctx.moveTo(crashX, crashY); // Start from dot position
            ctx.lineTo(w, crashY);
            ctx.stroke();

            // Crash rate label at the end of horizontal line
            const crashRate = crashMult.toFixed(5);
            const crashText = `${crashRate}`; // Removed 'x' suffix
            ctx.font = "bold 24px Arial"; // Scaled font
            ctx.fillStyle = "#fff";
            ctx.textAlign = "left";
            const crashLabelWidth = ctx.measureText(crashText).width + 24;
            const crashLabelX = w - this.chartMargin - crashLabelWidth - 10;
            const crashLabelY = crashY - 16;

            // Label background (blue - maintain color)
            ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
            ctx.fillRect(crashLabelX, crashLabelY, crashLabelWidth, 36);

            // Label text
            ctx.fillStyle = "#fff";
            ctx.fillText(crashText, crashLabelX + 12, crashY + 8);
        }

        // X-axis labels (time) - 10 second intervals with dynamic count
        ctx.fillStyle = "#8a9ba8";
        ctx.font = "20px Arial"; // Scaled font for mobile
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";

        // Draw labels and grid based on 10s intervals (to accommodate 60s trade window)
        for (let i = 0; i < drawPoints.length - 1; i++) {
            const p1 = drawPoints[i];
            const p2 = drawPoints[i + 1];

            if (p1.timestamp && p2.timestamp) {
                const interval = 10000; // 10 seconds in ms
                let firstTick = Math.ceil(p1.timestamp / interval) * interval;

                for (let t = firstTick; t <= p2.timestamp; t += interval) {
                    const ratio = (t - p1.timestamp) / (p2.timestamp - p1.timestamp);
                    const tx = p1.x + (p2.x - p1.x) * ratio;

                    if (tx >= 0 && tx <= w) {
                        // Draw vertical grid line
                        ctx.strokeStyle = "rgba(68, 75, 89, 0.3)"; // Reduced opacity for subtle grid
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(tx, 0);
                        ctx.lineTo(tx, this.baseY);
                        ctx.stroke();

                        // Draw time label
                        const date = new Date(t);
                        const label = date.getHours().toString().padStart(2, '0') + ":" +
                            date.getMinutes().toString().padStart(2, '0') + ":" +
                            date.getSeconds().toString().padStart(2, '0');
                        ctx.fillStyle = "#8a9ba8";
                        ctx.fillText(label, tx, h - 10);
                    }
                }
            }
        }

        // Future time projection (right area) - 10 second intervals
        if (drawPoints.length >= 2) {
            const p1 = drawPoints[drawPoints.length - 2];
            const lastP = drawPoints[drawPoints.length - 1];
            if (p1.timestamp && lastP.timestamp && lastP.x > p1.x) {
                const msPerPixel = (lastP.timestamp - p1.timestamp) / (lastP.x - p1.x);
                const interval = 10000;
                let nextTick = Math.ceil((lastP.timestamp + 1) / interval) * interval;

                for (let t = nextTick; ; t += interval) {
                    const tx = lastP.x + (t - lastP.timestamp) / msPerPixel;
                    if (tx > w) break;

                    if (tx > lastP.x) {
                        // Draw vertical grid line
                        ctx.strokeStyle = "rgba(68, 75, 89, 0.3)";
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(tx, 0);
                        ctx.lineTo(tx, this.baseY);
                        ctx.stroke();

                        // Draw time label
                        const date = new Date(t);
                        const label = date.getHours().toString().padStart(2, '0') + ":" +
                            date.getMinutes().toString().padStart(2, '0') + ":" +
                            date.getSeconds().toString().padStart(2, '0');
                        ctx.fillStyle = "#8a9ba8";
                        ctx.fillText(label, tx, h - 10);
                    }
                }
            }
        }

        // Calculate stable msPerPixel ratio from the entire visible range for better accuracy
        if (drawPoints.length >= 2) {
            const p1 = drawPoints[drawPoints.length - 2];
            const lastP = drawPoints[drawPoints.length - 1];
            if (p1.timestamp && lastP.timestamp && lastP.x > p1.x) {
                let stableMsPerPixel = (lastP.timestamp - p1.timestamp) / (lastP.x - p1.x);
                if (drawPoints.length >= 3) {
                    const firstPoint = drawPoints[0];
                    const lastPoint = drawPoints[drawPoints.length - 1];
                    if (firstPoint.timestamp && lastPoint.timestamp && lastPoint.x > firstPoint.x) {
                        stableMsPerPixel = (lastPoint.timestamp - firstPoint.timestamp) / (lastPoint.x - firstPoint.x);
                    }
                }
                // === ACTIVE TRADE ANNOTATIONS (BUY/SELL lines + labels) ===
                if (drawPoints.length >= 2 && this.engine.activeTrades && this.engine.activeTrades.length > 0) {
                    // Auto-purge any trades whose expiry time has passed — prevents stale lines
                    const now_ts = getServerTime();
                    this.engine.activeTrades = this.engine.activeTrades.filter(t => t.expiryTime > now_ts);

                    // Get the very last point in the visible trace (the pulsing head)
                    const lastPointInTrace = drawPoints[drawPoints.length - 1];

                    // Calculate stable msPerPixel ratio from the entire visible range for better accuracy.
                    // CRITICAL: We MUST NOT use the very last point in the array because during "started"
                    // status, the last point is artificially animated (eased) and lacks a true server timestamp.
                    // Mixing animated X-coordinates with linear time causes the entry/expiry indicators to wobble.
                    let stableMsPerPixel = 1; // Fallback
                    if (drawPoints.length >= 2) {
                        const firstPoint = drawPoints[0];
                        // CRITICAL: We MUST exclude the animated "head" point from the ratio
                        // calculation because its X-coordinate is eased/non-linear.
                        const lastRealPointCandidate = drawPoints[drawPoints.length - 1];
                        const lastRealPoint = lastRealPointCandidate.isLive
                            ? drawPoints[drawPoints.length - 2]
                            : lastRealPointCandidate;

                        if (firstPoint && lastRealPoint && firstPoint.timestamp && lastRealPoint.timestamp && lastRealPoint.x > firstPoint.x) {
                            stableMsPerPixel = (lastRealPoint.timestamp - firstPoint.timestamp) / (lastRealPoint.x - firstPoint.x);
                        } else {
                            // Fallback using whole range if filtered fails
                            const p1_fb = drawPoints[0];
                            const plast_fb = drawPoints[drawPoints.length - 1];
                            if (plast_fb.x > p1_fb.x) {
                                stableMsPerPixel = (plast_fb.timestamp - p1_fb.timestamp) / (plast_fb.x - p1_fb.x);
                            }
                        }
                    }

                    this.engine.activeTrades.forEach(trade => {
                        if (!lastPointInTrace) return;

                        // Skip drawing if the trade's expiry has already passed
                        if (trade.expiryTime && getServerTime() > trade.expiryTime) {
                            return;
                        }

                        // 2. Multiplier Check: Specifically during active round to prevent premature rise
                        if (this.state.status === 'started') {
                            if (currentMult === null || currentMult < trade.entryMult) {
                                return;
                            }
                        }

                        // Calculate entry Y position
                        const entryY = this.getYForMult(trade.entryMult, yScaleFactor);

                        // Find exact entry point position
                        let entryX = 0;
                        let foundExactPosition = false;

                        // === CANDLE MODE: snap entryX to the centre of the matching candle ===
                        if (this.state.chartType === 'candle' && this._candleLayout && this._candleLayout.length > 0) {
                            const tw = this._candleTimeWindowMs || 3000;
                            const entryBin = Math.floor(trade.entryTime / tw);
                            let bestCandle = null;
                            for (const c of this._candleLayout) {
                                if (c.binStartTime !== undefined) {
                                    const cBin = Math.floor(c.binStartTime / tw);
                                    if (cBin === entryBin) { bestCandle = c; break; }
                                }
                            }
                            // Nearest candle fallback
                            if (!bestCandle) {
                                let minDiff = Infinity;
                                for (const c of this._candleLayout) {
                                    if (c.binStartTime !== undefined) {
                                        const diff = Math.abs(c.binStartTime - trade.entryTime);
                                        if (diff < minDiff) { minDiff = diff; bestCandle = c; }
                                    }
                                }
                            }
                            if (bestCandle) {
                                entryX = bestCandle.x;
                                foundExactPosition = true;
                            }
                        }

                        // === LINE MODE: interpolate between data points ===
                        if (!foundExactPosition) {
                            for (let i = 0; i < drawPoints.length - 1; i++) {
                                const point1 = drawPoints[i];
                                const point2 = drawPoints[i + 1];

                                if (point1.timestamp && point2.timestamp) {
                                    if (trade.entryTime >= point1.timestamp && trade.entryTime <= point2.timestamp) {
                                        const timeDiff = point2.timestamp - point1.timestamp;
                                        const timeOffset = trade.entryTime - point1.timestamp;
                                        const ratio = timeDiff > 0 ? timeOffset / timeDiff : 0;
                                        entryX = point1.x + (point2.x - point1.x) * ratio;
                                        foundExactPosition = true;
                                        break;
                                    } else if (Math.abs(trade.entryTime - point1.timestamp) < 50) {
                                        entryX = point1.x;
                                        foundExactPosition = true;
                                        break;
                                    }
                                }
                            }

                            if (!foundExactPosition && drawPoints.length > 0) {
                                const lastPoint = drawPoints[drawPoints.length - 1];
                                if (lastPoint.timestamp && Math.abs(trade.entryTime - lastPoint.timestamp) < 50) {
                                    entryX = lastPoint.x;
                                    foundExactPosition = true;
                                }
                            }

                            if (!foundExactPosition && drawPoints.length > 0) {
                                const firstP = drawPoints[0];
                                if (firstP.timestamp) {
                                    entryX = firstP.x + ((trade.entryTime - firstP.timestamp) / stableMsPerPixel);
                                } else {
                                    entryX = lastP.x;
                                }
                            }
                        }

                        // Safety clamp: ensure entry marker never wildly appears beyond the chart head
                        // (which happens if trade.entryTime is somehow slightly > lastP.timestamp due to sub-ms drift)
                        if (entryX > lastP.x) Math.max(0, entryX = lastP.x - 2); // Put it slightly behind the head


                        // Place expiry line exactly one trade-duration to the right of the entry.
                        // This directly uses the current px/ms density (which accounts for zoom).
                        const tradeDurationMs = trade.expiryTime - trade.entryTime;
                        const tradeExpX = entryX + (tradeDurationMs / stableMsPerPixel);

                        // Determine colors based on trade type
                        const isBuy = trade.slot === 1;
                        const markerColor = isBuy ? "rgba(0, 255, 136, 0.85)" : "rgba(255, 60, 60, 0.85)";
                        const lineColor = isBuy ? "rgba(0, 255, 136, 0.75)" : "rgba(255, 60, 60, 0.75)";

                        // Horizontal Trade Line — Solid, strictly connecting entry and expiry
                        ctx.save();
                        ctx.strokeStyle = lineColor;
                        ctx.lineWidth = 3.5;
                        ctx.setLineDash([]);
                        ctx.beginPath();
                        ctx.moveTo(entryX, entryY);
                        // End at the vertical expiration line if visible, otherwise extend to width
                        const endX = (tradeExpX > 0 && tradeExpX <= w) ? tradeExpX : w;
                        ctx.lineTo(endX, entryY);
                        ctx.stroke();
                        ctx.restore();

                        // Entry Dot
                        ctx.fillStyle = markerColor;
                        ctx.beginPath();
                        ctx.arc(entryX, entryY, 7, 0, 2 * Math.PI);
                        ctx.fill();
                        ctx.strokeStyle = "#ffffff";
                        ctx.lineWidth = 2;
                        ctx.stroke();

                        // Countdown Label at Entry
                        const msLeft = Math.max(0, trade.expiryTime - now_ts);
                        const secsLeft = Math.ceil(msLeft / 1000);
                        const countdownText = msLeft > 0 ? `${secsLeft}s` : 'Done';
                        const labelText = `${trade.amount} KES ⏱ ${countdownText}`;

                        ctx.save();
                        ctx.font = "bold 26px Arial"; // Scaled for mobile
                        const labelWidth = ctx.measureText(labelText).width + 32;
                        const labelHeight = 42;
                        const labelX = entryX + 18;
                        const labelRectY = entryY - labelHeight - 14;

                        ctx.fillStyle = markerColor;
                        const r = 8;
                        ctx.beginPath();
                        if (ctx.roundRect) {
                            ctx.roundRect(labelX - 12, labelRectY, labelWidth, labelHeight, r);
                        } else {
                            ctx.rect(labelX - 12, labelRectY, labelWidth, labelHeight); // Fallback
                        }
                        ctx.fill();

                        ctx.fillStyle = "#ffffff";
                        ctx.textAlign = "left";
                        ctx.textBaseline = "middle";
                        ctx.fillText(labelText, labelX, labelRectY + labelHeight / 2);
                        ctx.restore();

                        // Vertical Expiry Line
                        // Always draw it at the exact calculated pixel position:
                        ctx.strokeStyle = markerColor;
                        ctx.lineWidth = 3.5;
                        ctx.setLineDash([]);
                        ctx.beginPath();
                        ctx.moveTo(tradeExpX, 40);
                        ctx.lineTo(tradeExpX, this.baseY);
                        ctx.stroke();

                        ctx.fillStyle = markerColor;
                        ctx.font = 'bold 16px Arial';
                        ctx.textAlign = 'center';
                        ctx.fillText('EXPIRY', tradeExpX, 28);
                    });
                }
            }
        }

        // Hover tooltip
        if (this.state.hoveredPoint) {
            const hp = this.state.hoveredPoint;
            const hx = Math.max(this.chartMargin, Math.min(hp.x, w - this.chartMargin));
            const hy = Math.max(this.maxChartY, Math.min(hp.y, h - this.chartMargin));

            // Horizontal line
            ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
            ctx.lineWidth = 2; // Scaled width
            ctx.setLineDash([10, 10]); // Scaled dash
            ctx.beginPath();
            ctx.moveTo(this.chartMargin, hy);
            ctx.lineTo(w - this.chartMargin, hy);
            ctx.stroke();
            ctx.setLineDash([]);

            // Highlight point with blue theme
            ctx.fillStyle = "#4a9ff5";
            ctx.beginPath();
            ctx.arc(hx, hy, 16, 0, 2 * Math.PI); // Scaled radius
            ctx.fill();
            ctx.strokeStyle = "#fff";
            ctx.lineWidth = 4; // Scaled width
            ctx.stroke();

            // Tooltip box
            const tooltipText = `${hp.mult.toFixed(2)}x`;
            ctx.font = "bold 28px Arial"; // Scaled font
            const textWidth = ctx.measureText(tooltipText).width;
            const padding = 16;
            const tooltipWidth = textWidth + padding * 2;
            const tooltipHeight = 48;
            let tooltipX = hx + 20;
            let tooltipY = hy - 30;
            // Keep tooltip in bounds
            if (tooltipX + tooltipWidth > w - this.chartMargin) tooltipX = hx - tooltipWidth - 20;
            if (tooltipY < this.maxChartY) tooltipY = hy + 40;

            ctx.fillStyle = "rgba(0, 0, 0, 0.8)";
            ctx.fillRect(tooltipX, tooltipY - tooltipHeight + padding, tooltipWidth, tooltipHeight);
            ctx.fillStyle = "#fff";
        }

        // Draw Floating Profit Popups (Card Style)
        if (this.popups && this.popups.length > 0) {
            for (let i = this.popups.length - 1; i >= 0; i--) {
                const p = this.popups[i];

                // Hide simulated popups when player has an active trade
                if (p.isSimulated && this.engine.activeTrades && this.engine.activeTrades.length > 0) {
                    continue;
                }

                let foundX = 0;
                let foundY = 0;
                let isFound = false;

                // Hybrid Card Anchoring:
                // 1. Player Card ("Me"): Fixed horizontally at 75% width, moves only vertically.
                // 2. Simulated Cards: Use interpolation to scroll left with the graph history.
                if (!p.isSimulated) {
                    foundX = w * 0.75;
                    const currentMinY = this.yScaleMin || 1.00;
                    const currentMaxY = this.yScaleMax || 1.80;
                    const currentScale = (this.baseY - this.maxChartY) / (currentMaxY - currentMinY);
                    foundY = this.baseY - (p.mult - currentMinY) * currentScale;
                    isFound = true;
                } else if (drawPoints.length > 0) {
                    // Use spawnRatio to map directly to a position along the visible drawPoints.
                    // This avoids unreliable mult-interpolation on a zigzag graph.
                    if (p.spawnRatio !== null && p.spawnRatio !== undefined) {
                        const targetIdx = Math.min(
                            Math.round(p.spawnRatio * (drawPoints.length - 1)),
                            drawPoints.length - 1
                        );
                        const targetPt = drawPoints[targetIdx];
                        foundX = targetPt.x;
                        foundY = targetPt.y;
                        isFound = true;
                    } else {
                        // Legacy path: real player popups without spawnRatio
                        let minDiff = Infinity;
                        let bestPt = drawPoints[0];
                        for (const pt of drawPoints) {
                            const diff = Math.abs(pt.mult - p.mult);
                            if (diff < minDiff) { minDiff = diff; bestPt = pt; }
                        }
                        foundX = bestPt.x;
                        foundY = bestPt.y;
                        isFound = true;
                    }
                }

                if (!isFound || foundX < -100) {
                    if (foundX < -200) this.popups.splice(i, 1);
                    continue;
                }

                ctx.save();
                ctx.globalAlpha = p.alpha;

                // Scaled dimensions for higher resolution mobile canvas
                const cardWidth = 240;
                const cardHeight = 80;
                const cornerRadius = 16;
                const cardX = foundX - cardWidth / 2;
                const cardY = foundY + p.offset - cardHeight / 2;

                // Draw Card Background (Glassmorphism / Faded)
                ctx.beginPath();
                ctx.moveTo(cardX + cornerRadius, cardY);
                ctx.lineTo(cardX + cardWidth - cornerRadius, cardY);
                ctx.quadraticCurveTo(cardX + cardWidth, cardY, cardX + cardWidth, cardY + cornerRadius);
                ctx.lineTo(cardX + cardWidth, cardY + cardHeight - cornerRadius);
                ctx.quadraticCurveTo(cardX + cardWidth, cardY + cardHeight, cardX + cardWidth - cornerRadius, cardY + cardHeight);
                ctx.lineTo(cardX + cornerRadius, cardY + cardHeight);
                ctx.quadraticCurveTo(cardX, cardY + cardHeight, cardX, cardY + cardHeight - cornerRadius);
                ctx.lineTo(cardX, cardY + cornerRadius);
                ctx.quadraticCurveTo(cardX, cardY, cardX + cornerRadius, cardY);
                ctx.closePath();

                // Background color based on trade type (Green for Buy, Red for Sell)
                ctx.fillStyle = p.type === "sell" ? "rgba(239, 68, 68, 0.8)" : "rgba(16, 185, 129, 0.8)";
                ctx.fill();
                ctx.strokeStyle = "rgba(255, 255, 255, 0.1)";
                ctx.lineWidth = 2;
                ctx.stroke();

                // Draw User Icon (Circle)
                const iconSize = 48;
                const iconX = cardX + 16;
                const iconY = cardY + 16;
                ctx.beginPath();
                ctx.arc(iconX + iconSize / 2, iconY + iconSize / 2, iconSize / 2, 0, Math.PI * 2);
                ctx.fillStyle = "rgba(255, 255, 255, 0.2)";
                ctx.fill();

                // Draw User Silhouette Icon
                ctx.fillStyle = "#fff";
                const centerX = iconX + iconSize / 2;
                const centerY = iconY + iconSize / 2;

                // Head
                ctx.beginPath();
                ctx.arc(centerX, centerY - 6, 7, 0, Math.PI * 2);
                ctx.fill();

                // Body (Shoulders/Torso)
                ctx.beginPath();
                ctx.moveTo(centerX - 14, centerY + 16);
                ctx.quadraticCurveTo(centerX, centerY + 4, centerX + 14, centerY + 16);
                ctx.fill();

                // Draw Content (Username and Amount)
                ctx.textAlign = "left";
                ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
                ctx.font = "20px Arial";
                ctx.fillText(p.username, iconX + iconSize + 16, cardY + 28);

                ctx.fillStyle = "#fff";
                ctx.font = "bold 24px Arial";
                ctx.fillText(p.subtext, iconX + iconSize + 16, cardY + 56);

                ctx.restore();

                // Update state for next frame
                p.alpha -= 0.005; // Fade over ~3 seconds

                // Remove if invisible
                if (p.alpha <= 0) {
                    this.popups.splice(i, 1);
                }
            }
        }
    }

    gameLoop() {
        if (!this._isMounted || !this.isAnimating) return;

        // Smooth interpolation for both started and ticker modes
        let targetMult = 1.00;
        if (this.state.status === "started" && this.startTime) {
            const elapsed = Date.now() - this.startTime;
            const growth = Math.exp(0.0007 * elapsed);
            const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.00 };
            targetMult = lastPoint.mult * growth;
        } else if (this.points.length > 0) {
            targetMult = this.points[this.points.length - 1].mult;
        }

        const lerpFactor = 0.22; // Adjustment for speed
        this.currentLerpMult = this.currentLerpMult + (targetMult - this.currentLerpMult) * lerpFactor;

        const ctx = this.canvasRef.current?.getContext("2d");
        if (ctx) {
            this.drawChart(ctx);
        }

        this.animationRef.gameLoop = requestAnimationFrame(this.gameLoop);
    }

    clearAnimationData() {
        const canvas = this.canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext("2d");
            this.drawChart(ctx);
        }

        this.isAnimating = false;
        cancelAnimationFrame(this.animationRef.gameLoop);
        this.startTime = null;
    }

    startCrashAnimation() {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        this.gameISStarted.current = true;
        const lastBustX = this.points.length > 0 ? this.points[this.points.length - 1].x : this.chartMargin;
        this.startRoundX = lastBustX;
        this.startTime = Date.now() - this.serverElapsed;
        this.isStopGame.current = true;
        this.isAnimating = true; // Start animation
        this.lastCrashPoint = null; // Clear crash indicator when new round starts

        // Initialize progressive drawing animation
        this.animatedX = lastBustX; // Start from last crash point
        this.lastLiveX = lastBustX;

        this.setState({ status: "started" });
        this.gameLoop(); // Draw initial frame and start loop
    }

    finish(data) {
        if (this._isMounted) {
            // console.log('Canvas finish_crash:', data);
        }
    }

    busted(data) {
        if (this._isMounted) {
            // console.log('busted_crash Data:', data);

            let { amount, time } = data;
            let rate = amount / 100; // Store raw value without rounding

            const numHistory = this.points.length;
            const step = numHistory > 0 ? (this.points[this.points.length - 1].x - this.chartMargin) / numHistory : 50; // Approximate step
            const bust_x = this.startRoundX + step;
            // Use stored yScaleFactor (computed in drawChart, but for consistency, we'll recompute here if needed)
            // Note: y is now computed dynamically in drawChart, so we store only x and mult; y is derived
            const now = new Date();
            const timeStr = now.getHours().toString().padStart(2, '0') + ":" +
                now.getMinutes().toString().padStart(2, '0') + ":" +
                now.getSeconds().toString().padStart(2, '0');
            this.points.push({ x: bust_x, mult: rate, time: timeStr, timestamp: now.getTime() }); // Store raw value
            this.lastMult = rate; // Update last mult for next continuation

            // Keep only last maxPoints points
            if (this.points.length > this.maxPoints) {
                this.points.shift();
            }

            this.averageBust = this.averageBust * 0.8 + rate * 0.2;

            this.setState({
                status: "busted",
                inPlay: false,
                rate: rate, // Store raw value
                timer: time,
                current_amount: rate, // Store raw value
                startedTime: Date.now() - time,
                timePassed: time,
            }, () => {
                Game["current_amount"] = rate.toFixed(5); // Format only for display
                this.isStopGame.current = false;
                const ctx = this.canvasRef.current?.getContext("2d");
                if (ctx) this.drawChart(ctx); // Draw bust state
                setTimeout(() => {
                    this.setState({ status: "idle" }, () => {
                        this.isAnimating = false;
                        cancelAnimationFrame(this.animationRef.gameLoop);
                        const finalCtx = this.canvasRef.current?.getContext("2d");
                        if (finalCtx) this.drawChart(finalCtx); // Redraw idle state
                    });
                    this.serverElapsed = 0;
                }, 1500);
            });
        }
    }

    status(data) {
        if (this._isMounted) {
            // console.log('Canvas game_status:', data);

            let { amount, time, md5, status: newStatus, crashes } = data;

            // Restore points from history FIRST (synchronously, before setState triggers re-render)
            let hasValidPoints = false;
            if (crashes && crashes.length > 0) {
                this.points = crashes
                    .map(c => {
                        let rawValue = c.crash !== undefined ? c.crash : c.amount;
                        let mult = rawValue / 100; // Store raw value without rounding
                        let timeStr = "";
                        let timestamp = null;
                        if (c.time) {
                            const d = new Date(c.time.replace(' ', 'T'));
                            if (!isNaN(d.getTime())) {
                                timestamp = d.getTime();
                                timeStr = d.getHours().toString().padStart(2, '0') + ":" +
                                    d.getMinutes().toString().padStart(2, '0') + ":" +
                                    d.getSeconds().toString().padStart(2, '0');
                            }
                        }
                        return {
                            mult: mult, // Store raw value
                            time: timeStr,
                            timestamp: timestamp
                            // x and y will be calculated during drawChart
                        };
                    })
                    .filter(p => p.mult >= 1.0) // Filter out any points < 1.0 (invalid data)
                    .slice(-this.maxPoints);

                hasValidPoints = this.points.length > 0;
            }

            let rate = newStatus === "busted" ? (amount / 100).toFixed(2) : this.state.rate;
            let currentAmount;
            if (newStatus === "started") {
                const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.50 };
                const lastMult = lastPoint.mult;
                const growth = Math.exp(0.0007 * time);
                currentAmount = (lastMult * growth).toFixed(2);
                this.serverElapsed = time;
            } else {
                currentAmount = newStatus === "busted" ? rate : Game['current_amount'];
            }

            this.setState(
                {
                    status: newStatus,
                    timer: time,
                    // Only stop "connecting" (loader) once we have valid history data, or game is active
                    connecting: hasValidPoints || newStatus === "started" || newStatus === "busted" ? false : this.state.connecting,
                    rate: rate,
                    current_amount: currentAmount,
                    startedTime:
                        newStatus === "started" ? Date.now() - time :
                            newStatus === "busted" ? Date.now() - time : this.state.startedTime,
                    timePassed: newStatus === "started" || newStatus === "busted" ? time : this.state.timePassed,
                },
                () => {
                    const ctx = this.canvasRef.current?.getContext("2d");
                    if (newStatus === "busted") {
                        Game["current_amount"] = rate;
                        // DON'T call this.busted(data) — crashes array already has all history.
                        // Calling busted() would push a DUPLICATE point using amount/100 which may
                        // inject mult=1.00 when amount=100 and corrupt the Y-axis scale.
                        this.isStopGame.current = false;

                        // Set lastCrashPoint from last existing point for crash indicator display
                        if (this.points.length > 0) {
                            const lastP = this.points[this.points.length - 1];
                            this.lastCrashPoint = { x: 0, y: 0, mult: lastP.mult, time: lastP.time };
                        }

                        if (ctx) this.drawChart(ctx);
                        setTimeout(() => {
                            this.setState({ status: "idle" }, () => {
                                this.isAnimating = false;
                                cancelAnimationFrame(this.animationRef.gameLoop);
                                const finalCtx = this.canvasRef.current?.getContext("2d");
                                if (finalCtx) this.drawChart(finalCtx);
                            });
                            this.serverElapsed = 0;
                        }, 1500);
                    } else if (newStatus === "started") {
                        Game["current_amount"] = currentAmount;
                        if (!this.gameISStarted.current) {
                            this.startCrashAnimation();
                        }
                    } else {
                        // For idle/waiting/finish: draw once and stop animation
                        if (ctx) this.drawChart(ctx);
                        this.isAnimating = false;
                        cancelAnimationFrame(this.animationRef.gameLoop);
                        this.gameISStarted.current = false;
                    }
                }
            );
        }
    }

    render() {
        const { t } = this.props;
        const { loadingError } = this.state;

        return (
            <Card className="no-shadow mb-0 game-wrapper-card game-chart-black-animation">
                <Card.Body className="bg-body text-center no-shadow pt-0 static-snow p-0" id="canvasPart">
                    <div className="game-holder">
                        <Card className="mb-0 bg-transparent">
                            <Card.Body className="pt-0" style={{ padding: 0 }}>
                                <div className="asset-label-card">
                                    <Menus />
                                </div>
                                <div className="bottom-controls-container" style={{ position: 'relative', zIndex: 1 }}>

                                    <div className="asset-label-card-bottom">
                                        <MarketTicker
                                            symbol={this.state.selectedSymbol}
                                            onSymbolChange={this.handleMarketSymbolChange}
                                        />


                                    </div>



                                    <div className="chart-type-toggle-card">
                                        <div className="chart-type-toggle d-flex">
                                            <button
                                                className={`btn btn-sm ${this.state.chartType === 'line' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                onClick={() => this.toggleChartType('line')}
                                                style={{ padding: '2px 8px' }}
                                            >
                                                <i className="mdi mdi-chart-line" />
                                            </button>
                                            <button
                                                className={`btn btn-sm ${this.state.chartType === 'candle' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                onClick={() => this.toggleChartType('candle')}
                                                style={{ padding: '2px 8px' }}
                                            >
                                                <i className="mdi mdi-chart-bar" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="live-traders-card">
                                    <span className="live-traders-label text-uppercase">Live Traders:</span>
                                    <span className="live-traders-count text-white">{this.state.liveTraders.toLocaleString()}</span>
                                    <i className="fa fa-eye live-traders-icon ml-1"></i>
                                </div>
                                <div className="canvas-container" style={{ position: 'relative', minHeight: 400 }}>
                                    <canvas
                                        ref={this.canvasRef}
                                        style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                            visibility: (this.state.connecting || this.state.loadingMarket) ? 'hidden' : 'visible'
                                        }}
                                    />
                                    {(this.state.connecting || this.state.loadingMarket) && (
                                        <div className="game-loader text-center" style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                            zIndex: 10
                                        }}>
                                            <div className="spinner-grow text-info" role="status" />
                                            {/* <div className="mt-3 text-info text-uppercase font-weight-bold" style={{ letterSpacing: '2px', fontSize: '13px' }}>Loading {this.state.selectedSymbol}...</div> */}
                                        </div>
                                    )}
                                </div>
                                {loadingError && (
                                    <div style={{ color: "red", marginTop: "10px" }}>{loadingError}</div>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

Canvas.propTypes = {
    profit: PropTypes.string,
    im_in_game: PropTypes.bool,
    t: PropTypes.func,
};

const mapStateToProps = (state) => ({
    profit: state.items.profit,
    im_in_game: state.items.im_in_game,
});

export default connect(mapStateToProps, {})(Canvas);